/**
 * Checks if a pathname matches a route pattern (static or dynamic).
 * Works with both Pages Router route patterns (e.g. `/buy/[planType]`) and
 * App Router resolved pathnames (e.g. `/buy/pro`).
 */
export function matchesRoute(pathname: string, route: string): boolean {
  const cleanPathname = pathname.split('?')[0]
  const routeSegments = route.split('/')
  const pathnameSegments = cleanPathname.split('/')

  if (routeSegments.length !== pathnameSegments.length) {
    return false
  }

  for (let i = 0; i < routeSegments.length; i++) {
    const routeSegment = routeSegments[i]
    if (routeSegment.startsWith('[') && routeSegment.endsWith(']')) {
      continue
    }
    if (routeSegment !== pathnameSegments[i]) {
      return false
    }
  }

  return true
}

export function matchesAnyRoute(pathname: string, routes: string[]): boolean {
  return routes.some(route => matchesRoute(pathname, route))
}
